module.exports = __webpack_public_path__ + "img/10.b60d5626.jpg";